'use client';
import SSVMeeting2025 from './s-2025';
import SSVMeeting2026 from './conference';
import { I18nProvider } from './i18n/I18nProvider';
import { Locale } from './i18n/config';
export { I18nProvider } from './i18n/I18nProvider';
export { MeetingConfigProvider } from './s-2025/context/MeetingConfigContext';
export { MeetingStatus } from './s-2025/type';
export type { MeetingMainConfig } from './s-2025/type';
export { default as SSVMeeting2026 } from './conference';
export { SSVMeeting2026SignupPage } from './s-2026-signup';
export { SSVMeeting2026IndustryPartnerPage } from './s-2026-industry-partner';
export { SSVMeeting2026SignupEnPage } from './s-2026-signup-en';
export { ConferenceChatPage } from './conference-chat';
export { default as SSVNavbar } from './components/SSVNavbar';
export { default as SSVFooter } from './components/SSVFooter';

export { SSVMettingLive } from './s-live/index';

interface SSVMeetingContainerProps {
  defaultLocale?: Locale;
  isExternalDomain?: boolean;
  cmsData: any;
}

export const SSVMeetingContainer: React.FC<SSVMeetingContainerProps> = ({
  defaultLocale,
  isExternalDomain = false,
  cmsData,
}) => {
  return (
    <I18nProvider defaultLocale={defaultLocale}>
      <SSVMeeting2025
        data={cmsData}
        isExternalDomain={isExternalDomain}
      ></SSVMeeting2025>
    </I18nProvider>
  );
};

interface SSVMeeting2026ContainerProps {
  defaultLocale?: Locale;
  isExternalDomain?: boolean;
  cmsData?: any;
  site?: 'zh' | 'en';
  initialSnapshot?: import('./conference/initialSnapshot').ConferenceInitialSnapshot;
}

export const SSVMeeting2026Container: React.FC<SSVMeeting2026ContainerProps> = ({
  defaultLocale,
  isExternalDomain = false,
  cmsData,
  site,
  initialSnapshot,
}) => {
  return (
    <I18nProvider defaultLocale={defaultLocale}>
      <SSVMeeting2026
        data={cmsData}
        isExternalDomain={isExternalDomain}
        site={site}
        initialSnapshot={initialSnapshot}
      />
    </I18nProvider>
  );
};
